// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Tabs__tabsContainer__12nLx","myCol":"Tabs__myCol__1lj8h","myCol2":"Tabs__myCol2__2HhSQ","myCol3":"Tabs__myCol3__38ZaA"};